import React from 'react';
import PropTypes from 'prop-types';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import { FormattedMessageWrappedInSpan } from '../../misc';
import CustomDialog from './CustomDialog';

const LoginRedirectionConfirmDialog = props => {
  const { open, onRequestClose, onAcceptClick } = props;

  return (
    <CustomDialog
      hasFixedWidth={false}
      open={open}
      onRequestClose={onRequestClose}
    >
      <div className="notification-container">
        <DialogContent>
          <div className="notification-body">
            <FormattedMessageWrappedInSpan
              id="loginPage.redirection.confirmation.description"
              defaultMessage="Are you sure that your order is of an event before 2019 ?"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div className="notification-action">
            <button onClick={onRequestClose}>
              <FormattedMessageWrappedInSpan
                id="loginPage.redirection.confirmation.no"
                defaultMessage="No, I'm not sure"
              />
            </button>
            <button className="accept" onClick={onAcceptClick}>
              <FormattedMessageWrappedInSpan
                id="loginPage.redirection.confirmation.yes"
                defaultMessage="Yes, Go to Archive"
              />
            </button>
          </div>
        </DialogActions>
      </div>
    </CustomDialog>
  );
};

LoginRedirectionConfirmDialog.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  onAcceptClick: PropTypes.func,
};

export default LoginRedirectionConfirmDialog;
